import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'lh-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.css'],
})
export class BackButtonComponent implements OnInit {
  @Input() backRoute: string | string[] = '..';

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {}

  public onBackRoute() {
    let lastChild = this.route;
    while (lastChild.children.length > 0) {
      const lastChildIndex = lastChild!.children.length - 1;
      lastChild = lastChild!.children[lastChildIndex];
    }

    this.router.navigate(Array.isArray(this.backRoute) ? this.backRoute : [this.backRoute], {
      relativeTo: lastChild,
      queryParamsHandling: 'preserve'
    });
  }
}
